import { t } from '@/translations/i18n';
import type { IImageField } from '@/typescript/interfaces/IImageField';
import type { IProduct } from '@/typescript/interfaces/IProduct';
import type { IProductConfiguration } from '@/typescript/interfaces/IProductConfiguration';
import type { ITextField } from '@/typescript/interfaces/ITextField';

function getEmptyProduct(): IProduct {
    return {
        name: t('custom_product_name'),
        thumbnailUrl: '/images/custom_template_thumbnail.png',
        configuration: getEmptyProductConfiguration(),
    };
}

function getEmptyProductConfiguration(): IProductConfiguration {
    return {
        poleColor: '#ffffff',
        isPoleColorEditable: true,
        fields: [getEmptyTextField(), getEmptyImageField()],
        isMat: false,
    };
}

function getEmptyTextField(): ITextField {
    return {
        id: window.crypto.randomUUID(),
        transform: {
            position: {
                x: 0,
                y: 0,
            },
            angle: 0,
            scale: {
                x: 1,
                y: 1,
            },
        },
        editable: true,
        font: 'Bebas Neue',
        fontSize: 25,
        defaultText: t('text_input_placeholder'),
        color: '#000000',
        isBold: false,
        isUnderlined: false,
        isItalic: false,
    };
}

function getEmptyImageField(): IImageField {
    return {
        id: window.crypto.randomUUID(),
        transform: {
            position: {
                x: 0,
                y: 0,
            },
            angle: 0,
            scale: {
                x: 1,
                y: 1,
            },
        },
        editable: true,
    };
}

export { getEmptyProduct, getEmptyImageField, getEmptyProductConfiguration, getEmptyTextField };
